export function MedicalAttendancesByCid() {
	return <div>MedicalAttendancesByCidTable</div>;
}
